import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function SchoolEmailStep({ formData, setFormData }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.schoolEmail")}</h2>
      <input
        ref={inputRef}
        type="email"
        value={formData.schoolEmail}
        onChange={e =>
          setFormData({ ...formData, schoolEmail: e.target.value })
        }
      />
      <p className="muted">{t("Start.info.schoolEmail")}</p>
    </>
  );
}
